module.exports = __webpack_public_path__ + "img/collection-memoireRingsGrowingMemoires@2x.a872555.jpg";